import * as $ from 'jquery';
import Debouncer from './Debouncer';

let requestData: { [key: string]: any } = {};
function updateFieldInRequestData(field: HTMLInputElement, event: JQuery.Event, timeout: number) {
    // Add new value to be sent
    const name = field.name.replace(/\[/g, '(').replace(/\]/g, ')'); // IMP: hack since can't use [ and ] in names. converted back in functins.php
    const qty = Number.parseInt(field.value ? field.value : '0');
    requestData[name] = qty;

    updateCartDebouncer.runSpecifyTime(timeout, event);
}

// Debounce update cart on field change
const updateCartDebouncer = new Debouncer((event: JQuery.Event) => {
    // Only update cart after initial load is done, because that initial load is what populates quantity fields.
    updateCart();
}, false, 1_000, true);

// Cart call to load and populate quantity fields
updateCart(false, () => {
    // Changed (blurred)
    $(document).on('change', '.productResultsLayout .quantity input', function(event: JQuery.Event) {
        const incrementControlFocused = $('.incrementControl:focus').length !== 0;
        updateFieldInRequestData(this, event, incrementControlFocused ? 1_000 : 500);
    });
    // Typing (they may not blur so need timeout)
    $(document).on('input', '.productResultsLayout .quantity input', function(event: JQuery.Event) {
        updateFieldInRequestData(this, event, 3_000);
    });
    // Move mouse / away from +/-
    $('.incrementControl').on('blur mouseout', (event: JQuery.Event) => {
        if (updateCartDebouncer.isWaitingOnTimeout()) {
            // Essentially can stop waiting (unless the focus on new field, see on('focus', ....) below)
            updateCartDebouncer.runSpecifyTime(250, event);
        }
    });
    // Focus new field, so if was blurred, let's wait longer
    $(document).on('focus', '.productResultsLayout .quantity input', (event: JQuery.Event) => {
        if (updateCartDebouncer.isWaitingOnTimeout()) {
            updateCartDebouncer.runSpecifyTime(1_000, event);
        }
    });
});

let lastDataSentJson: string = null;

interface ProductData {
    name: string;
    qty?: number;
}

function updateCart(update: boolean = true, done: () => void = undefined) {
    const $fields = $('.productQuantity');

    // Clone what needs to be sent to server
    let data = update ? {...requestData} : {};
    if (update) {
        // Sending update data (otherwise simply sending request to get cart data)
        data.do = 'update';
        requestData = {};
    }

    const dataJson = JSON.stringify(data);
    
    if (lastDataSentJson !== dataJson) {
        // Sending because data changed

        // Spinner and do NOT allow editing of fields
        // $fields.prop('readonly', true);
        $('.products-table__cartButton').addClass('isWaiting');

        // console.log('Sending update cart', data);

        $.ajax({
            type: 'POST',
            url: '/wp-json/kona/v1/cart',
            data,
            dataType: 'json', // Response type
        })
        .done(function(data, textStatus, jqXHR) {
            // console.log('   Cart update success, now updating quantities and messages');

            // Set quantity and add Messages
            for (let fieldIndex = 0; fieldIndex < $fields.length; fieldIndex++) {
                const field = $fields[fieldIndex];
                if (field instanceof HTMLInputElement) {
                    // const $field = $(field);
                    const name = field.name;
                    const item = data.i[name] ?? { qty: 0 };
                    const cart_id = field.getAttribute('data-cartid');

                    // Update quantity
                    const newValue = data.cartContents[cart_id] ?? 0;
                    if (Number.parseInt(field.value) !== newValue) {
                        field.value = newValue;
                        // TODO:
                        // IMP: Triggering an event for every field (when many) is very slow
                        // field.dispatchEvent(new Event('change', {bubbles: true}));
                    }

                    // Error
                    field.classList.toggle('error', !!item.error);

                    // Message
                    const $fieldQuantityDiv = $(field).parents('.quantityContainer');
                    let $message = $('.productMessage', $fieldQuantityDiv);
                    if ($message.length !== 0 || item.message) {
                        if ($message.length === 0) {
                            $message = $('<div class="productMessage"/>');
                            $message.appendTo($fieldQuantityDiv);
                        }
                        $message.html(item.message ? item.message : '');
                        $message.toggleClass('productMessage--error', !!item.error);
                    }
                }
            }

            // console.log('   Next cart total');

            // Update cart total
            let cartCountTotal = 0;
            (Object.keys(data.cartContents) as (keyof typeof String)[]).forEach((key, index) => {
                cartCountTotal += Number.parseInt(data.cartContents[key]);
            });
            $('.cartCountTotal').text(cartCountTotal);

            // console.log('   Event about cart updates done');
            document.dispatchEvent(new Event('cartUpdateDone', {}));

            // console.log('   Success done');
        })
        .fail(function(jqXHR, textStatus) {
            console.error('Cart update failed', jqXHR.responseJSON);
        })
        .then(() => {
            // Remove spinner and fields can be edited again
            // $fields.prop('readonly', false);
            $('.products-table__cartButton').removeClass('isWaiting');

            if (done !== undefined) {
                // Run done callback
                done();
            }

            // Keep track of what was sent last to ensure we do not send when nothing has changed
            // (We regenerate data so it is what fields updated to after server responded)
            //lastDataSentJson = JSON.stringify(createUpdateCartData($fields, true));
            lastDataSentJson = JSON.stringify(data);

            // console.log('Done update cart');
        })
        ;
    }
}
